import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconXUpgrade = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    viewBox="0 0 20 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FF0004"
      d="M15.86 14.64c.507.47.507 1.29 0 1.758a1.212 1.212 0 0 1-.86.352c-.352 0-.664-.117-.898-.352L10 12.297l-4.14 4.101a1.212 1.212 0 0 1-.86.352c-.352 0-.664-.117-.898-.352a1.205 1.205 0 0 1 0-1.757L8.203 10.5 4.102 6.398a1.205 1.205 0 0 1 0-1.757 1.205 1.205 0 0 1 1.757 0L10 8.742l4.102-4.101a1.205 1.205 0 0 1 1.757 0c.508.468.508 1.289 0 1.757l-4.101 4.141 4.101 4.102Z"
    />
  </svg>
));
export default SvgIconXUpgrade;
